import axios from "./axios";

const authApi = {
  register: (userData) => axios.post("/register", userData),
  login: (credentials) => axios.post("/login", credentials),
  logout: () => axios.post("/logout"),
  getProfile: () => axios.get("/profile"),
  updateProfile: (profileData) => axios.put("/profile", profileData),
  // Admin APIs
  listUsers: () => axios.get("/admin/users"),
  deleteUser: (userId) => axios.delete(`/admin/users/${userId}`),
  getUserStats: () => axios.get("/admin/users/stats"),
};

export default authApi;
